const isCI = require('is-ci');
const { execSync } = require('child_process');

describe('.wuf/components.json', () => {
  it('should not have changes after build in CI', () => {
    if (isCI) {
      /* This test ensures that `.wuf/components.json` file does not include unexpected changes after `npm run build`
       *
       * `.wuf/components.json` acts as a database of components in the library. Changes in this file can impact other
       * build tools, so it's important that changes in `.wuf/components.json` go through a review and don't get
       * unnoticed.
       *
       * If this test fails, run build locally, commit changes and submit a PR for a review.
       */

      const checkDiff = () => {
        try {
          execSync('git diff --exit-code HEAD -- .wuf/components.json', {
            encoding: 'utf8',
          });
        } catch (e) {
          throw new Error(
            'Changes detected in `.wuf/components.json`. Please review those changes and commit if they are valid.',
          );
        }
      };

      expect(checkDiff).not.toThrow();
    }
  });
});
